import { render, staticRenderFns } from "./InputCustomerData.vue?vue&type=template&id=81e18c0c&scoped=true&lang=pug"
import script from "./InputCustomerData.vue?vue&type=script&lang=js"
export * from "./InputCustomerData.vue?vue&type=script&lang=js"
import style0 from "./InputCustomerData.vue?vue&type=style&index=0&id=81e18c0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e18c0c",
  null
  
)

export default component.exports